import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchVisitExternalVideoTypes = async ({ visitId }) => {
  const token = localStorage.getItem("token");

  const res = await axios.get(`${__API_URL__}/api/photos/visits/${visitId}/external-video-types/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const selectTypes = (data) => data.external_video_types;

const useGetVisitExternalVideoTypes = ({ visitId, enabled = true, select = selectTypes }) => {
  return useQuery({
    queryKey: ["visit_external_video_types", visitId],
    queryFn: () => fetchVisitExternalVideoTypes({ visitId }),
    select,
    enabled: enabled && Boolean(visitId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load visit external video types");
    },
  });
};

export default useGetVisitExternalVideoTypes;
